<template>
  <div class="container-fluid" id="header">
    <div class="col-lg-12">
      <a href="index.html">
        <img src="data/logo.png" id="logoImg"/>
        <h3 style="text-align:left; display: inline-block">Audio Explorer</h3>
      </a>
      <img id= "aboutImg" src="data/icons/about.png" alt="About this project" class="float-right" @click="aboutPage">
      <div class="btn-group" role="group" id="toggle" aria-label="Controls">
        <button type="button" class="btn btn-light btn-sm"
                @click="toggleView('Main View')"
                :class="{active : currentView === 'Main View'}">Main View
        </button>
        <button type="button" class="btn btn-light btn-sm"
                @click="toggleView('Month View')"
                :class="{active : currentView === 'Month View'}">Month View
        </button>
        <button type="button" class="btn btn-light btn-sm"
                @click="toggleView('Year View')"
                :class="{active : currentView === 'Year View'}">Year View
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import { speciesEventBus } from '../main';

  export default {
    name: 'Header',
    data: function() {
      return {
        currentView: "Main View"
      }
    },
    methods: {
      toggleView(view) {
        speciesEventBus.$emit('viewChanged', view);
        this.currentView = view;
      },
      aboutPage() {
        // Use sweetalret2
        this.$swal({
          title: 'About',
          width: 660,
          imageUrl: 'data/logo.png',
          imageHeight: 85,
          showCloseButton: true,
          focusConfirm: false,
          // backdrop: 'rgba(206, 225, 255, 0.45)',
          html: `Audio Explorer is a data visualization tool 
          that helps researchers analyze location specific audio recordings 
          over time and verify their authenticity.
          <br>
          This web app is part of our submission for the 
          <a href="http://www.vacommunity.org/VAST+Challenge+2018+MC1" target="_blank">2018 VAST Challenge. </a>
          <hr>
          <i>The Challenge:</i>
          Kasios Furniture stands accused of using a banned substance in their factory
          and dumping waste material in the northeast region of the nearby wildlife preserve. 
          Ornithologists say this has directly led to a decrease in the population of the local
          Rose-crested Blue Pipit. Kasios refutes this claim and has supplied 15 audio files recorded 
          across the Preserve that they insist are evidence that the Rose-Crested Blue Pipit population is fine.
          Provided with a large set of recorded bird calls with accurate identifications, it is our goal to 
          check the validity of Kasios’ claims, as well as characterize the patterns of all species in the preserve over time.           
          `,
          confirmButtonText: 'First-time user?',
          footer: `<p>Created by Colin Scruggs and Cameron Henkel      
          <a href="https://github.com/chadstolper/vast-challenge-2018-mc1" target="_blank">
          <img width="16" src="data/icons/GitHub-Mark-32px.png" alt="">   Visit our GitHub</a>
          </br>
          Special thanks to Dr. Stolper and the
          <a href="https://www.southwestern.edu/scope/" target="_blank"> SCOPE program </a>at Southwestern University</p>`,
        })
        .then((result) => {
          if (result.value) {
            this.$swal.mixin({
              width: 640,
              animation: false,
              confirmButtonText: 'Next &rarr;',
              showCloseButton: true,
              progressSteps: ['1', '2', '3', '4']
            }).queue([
              {
                title: 'Select a Kasios recording',
                html: `<img width="600" src="data/tutorial_gifs/tutorial_1.gif" alt="">
                <span style="font-weight: 700">1.</span> Prediction tags generated by our machine-learning models are added to the species list <br>
                <span style="font-weight: 700">2.</span> The location of the recording is plotted on the map <br>
                <span style="font-weight: 700">3.</span> The audio player loads the clip and shows the waveform or spectrogram
                `,
              },
              {
                title: 'Select a species',
                html: `<img width="600" src="data/tutorial_gifs/tutorial_2.gif" alt="">
                <span style="font-weight: 700">1.</span> Heatmap of species recording locations plotted on map <em>(all years of data by default)</em> <br>
                <span style="font-weight: 700">2.</span> The audio player loads the clip and shows the waveform or spectrogram
                `,
              },
              {
                title: 'Map controls',
                html: `<img width="600" src="data/tutorial_gifs/tutorial_3.gif" alt="">
                <span style="font-weight: 700">1.</span> Toggle between point and range selection<br>
                <span style="font-weight: 700">2.</span> Toggle history allows comparison between two selected ranges or individual years
                `,
            },
              {
                title: 'Month / Year View',
                html: `<img width="600" src="data/tutorial_gifs/tutorial_4.gif" alt="">
                <p>View historical data of all species recordings broken down by
                <span style="font-weight: 700">month</span> (across all years of data) or by each individual <span style="font-weight: 700">year</span> of collected data.
                `,
                confirmButtonText: 'Done',
              },
            ])
          }
        })
      }
    }
  }
</script>

<style scoped>
  #header {
    margin: 0 auto;
    padding: 10px 0 0 0;
    background-color: whitesmoke;
    z-index: 9000;
  }
  #logoImg {
    position: relative;
    height:45px;
    margin-right: 7px;
    bottom: 5px;
    padding: 5px;
  }
  #toggle {
    float: right;
    margin-right: 30px;
    margin-top: 2px;
  }
  .faded {
    opacity: 0.6;
  }
  a {
    text-decoration: none !important;
    color: #2d3e4f;
  }
  #aboutImg {
    cursor: pointer;
    height: 25px;
    margin: 5px 5px 0 0;
  }
  .swal2-popup #swal2-content {
    text-align: left !important;
  }
</style>